import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
    component: any;
    path: string;
    layout: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
    component,
    path,
    layout,
    ...rest
}) => {
    const sid = localStorage.getItem("sid");
    const isAuthenticated = Boolean(sid);

    return isAuthenticated ? (
        React.createElement(
            layout,
            {},
            React.createElement(component, { ...rest }),
        )
    ) : (
        <Navigate to="/login" />
    );
};

export default PrivateRoute;
